import React, { useState } from 'react';
import '../App.css';

// Função para tracking de conversão
const trackConversion = (eventName) => {
    const eventId = 'event_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);

    // Facebook Pixel (Browser) - Lead com dados customizados + eventID para desduplicação
    if (window.fbq) {
        window.fbq('track', 'Lead', {
            content_name: eventName,
            content_category: 'WhatsApp Click',
            origin: eventName
        }, { eventID: eventId });
    }

    // Google Analytics 4
    if (window.gtag) {
        window.gtag('event', eventName, {
            'event_category': 'engagement',
            'event_label': 'CTA Click'
        });
    }

    // Server-side Tracking (Meta CAPI via Cloudflare Worker)
    fetch('/api/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            eventName: 'Lead',
            eventSourceUrl: window.location.href,
            eventId: eventId,
            variant: 'A',
            origin: eventName
        })
    }).catch(err => console.error('CAPI Error:', err));

    // DataLayer para Google Tag Manager
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'lead_conversion',
        'eventCategory': 'Lead',
        'eventAction': 'WhatsApp Click',
        'eventLabel': eventName,
        'eventId': eventId
    });
};

const handleWhatsAppClick = (origin) => {
    trackConversion(`whatsapp_click_${origin}`);

    const messages = {
        'hero': 'Olá! Vi que a avaliação para Paciente Modelo é gratuita e gostaria de agendar a minha!',
        'social_cta': 'Olá! Vi os resultados de antes e depois e eu quero esse resultado também!',
        'cta_final': 'Olá! Quero aproveitar a avaliação gratuita para transformar meu sorriso agora!',
        'sticky_mobile': 'Olá! Quero agendar minha avaliação gratuita para ser paciente modelo.',
        'banner': 'Olá! Quero agendar minha avaliação gratuita para ser paciente modelo.'
    };

    const message = (messages[origin] || messages['hero']) + ' ¹';
    window.open(`https://wa.me/5511939300849?text=${encodeURIComponent(message)}`, '_blank');
};

function OriginalLP() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [itemsToShow, setItemsToShow] = useState(window.innerWidth <= 768 ? 1 : (window.innerWidth <= 992 ? 2 : 3));

    const minSwipeDistance = 50;

    const [showSticky, setShowSticky] = useState(false);
    const [notificationText, setNotificationText] = useState("");

    React.useEffect(() => {
        let timers = [];

        const stickyTimer = setTimeout(() => {
            setShowSticky(true);

            const firstMsgTimer = setTimeout(() => {
                setNotificationText("Vamos agendar uma avaliação gratuita?");

                const hideFirstMsgTimer = setTimeout(() => {
                    setNotificationText("");

                    const secondMsgTimer = setTimeout(() => {
                        setNotificationText("Temos apenas 5 vagas tá");

                        const hideSecondMsgTimer = setTimeout(() => {
                            setNotificationText("");
                        }, 4000);
                        timers.push(hideSecondMsgTimer);
                    }, 8000);
                    timers.push(secondMsgTimer);
                }, 4000);
                timers.push(hideFirstMsgTimer);
            }, 10000);
            timers.push(firstMsgTimer);
        }, 3000);
        timers.push(stickyTimer);

        const handleResize = () => {
            setItemsToShow(window.innerWidth <= 768 ? 1 : (window.innerWidth <= 992 ? 2 : 3));
        };

        window.addEventListener('resize', handleResize);
        return () => {
            timers.forEach(clearTimeout);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const cases = [
        {
            id: '01',
            before: 'Foco em Cor e Brilho',
            after: 'Eliminei o tom amarelado que me incomodava há anos. Impressionante como o brilho voltou em apenas uma tarde, com acabamento super natural e sem qualquer desgaste nos dentes.',
            imgBefore: '/paciente1-antes.webp',
            imgAfter: '/paciente1-depois.webp'
        },
        {
            id: '02',
            before: 'Foco em Alinhamento e Espaços',
            after: 'Os espaços entre os dentes sumiram e o sorriso ficou harmônico. Foi o melhor custo-benefício que encontrei: resultado de aparelho, mas resolvido em uma única sessão rápida.',
            imgBefore: '/paciente2-antes.webp',
            imgAfter: '/paciente2-depois.webp'
        },
        {
            id: '03',
            before: 'Foco em Harmonia Facial',
            after: 'Eu buscava um sorriso simétrico e iluminado. Consegui a estética de capa de revista com investimento acessível e a segurança de um material de altíssima qualidade profissional.',
            imgBefore: '/paciente3-antes.webp',
            imgAfter: '/paciente3-depois.webp'
        },
        {
            id: '04',
            before: 'Foco em Rejuvenescimento',
            after: 'Meus dentes estavam desgastados e com aparência envelhecida. Em poucas horas, recuperei o volume e formato ideal. O rosto todo parece muito mais firme, leve e renovado agora.',
            imgBefore: '/paciente4-antes.webp',
            imgAfter: '/paciente4-depois.webp'
        },
        {
            id: '05',
            before: 'Foco em Correção de Imperfeições',
            after: 'Corrigi irregularidades de forma e tamanho que me impediam de sorrir. Procedimento rápido, indolor e com um polimento que faz toda a diferença no brilho do meu dia a dia.',
            imgBefore: '/paciente5-antes.webp',
            imgAfter: '/paciente5-depois.webp'
        }
    ];

    const nextSlide = () => {
        const maxIndex = cases.length - itemsToShow;
        setCurrentIndex(prev => (prev >= maxIndex ? 0 : prev + 1));
    };

    const prevSlide = () => {
        const maxIndex = cases.length - itemsToShow;
        setCurrentIndex(prev => (prev <= 0 ? maxIndex : prev - 1));
    };

    const handleTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;
        if (isLeftSwipe) {
            nextSlide();
        } else if (isRightSwipe) {
            prevSlide();
        }
    };

    return (
        <div className="App">
            {/* ==========================================
                BANNER FLUTUANTE — ESCASSEZ
               ========================================== */}
            <div className="floating-banner">
                <i className="bi bi-clock-fill"></i>
                <strong>OFERTA LIMITADA:</strong> Apenas 5 vagas para Paciente Modelo no Grajaú e Região
            </div>

            {/* ==========================================
                HERO — PREÇO + OFERTA ACIMA DA DOBRA
               ========================================== */}
            <section className="hero-section wave-bg" style={{ padding: '110px 0 40px 0' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 text-center">
                            <div className="hero-badge">
                                <i className="bi bi-star-fill"></i> 50%+ ABAIXO DO MERCADO
                            </div>
                            <h1 className="hero-title">
                                Facetas em Resina: Resultado Premium
                            </h1>
                            <p className="hero-subtitle" style={{ marginBottom: '25px' }}>
                                Programa de <strong>Paciente Modelo</strong> no Grajaú. Mesmo material, mesma técnica, <strong>mesmo resultado</strong> das clínicas de luxo pela metade do preço.
                            </p>
                            <button
                                className="cta-button"
                                onClick={() => handleWhatsAppClick('hero')}
                            >
                                <i className="bi bi-whatsapp"></i>
                                QUERO MINHA AVALIAÇÃO GRATUITA
                            </button>
                            <div className="mt-3">
                                <small style={{ opacity: 0.9 }}>
                                    <i className="bi bi-shield-check"></i> Sem desgaste dental |
                                    <i className="bi bi-geo-alt-fill ms-2"></i> Grajaú • SP
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ==========================================
                O QUE É PACIENTE MODELO
               ========================================== */}
            <section style={{ background: '#f8f9fa', padding: '35px 0' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 text-center">
                            <h2 style={{ color: 'var(--azul-escuro)', fontWeight: '800', fontSize: '1.3rem', marginBottom: '12px' }}>
                                O que é <span style={{ color: 'var(--azul-medio)' }}>Paciente Modelo</span>?
                            </h2>
                            <p style={{ fontSize: '1.05rem', color: '#444', lineHeight: '1.6', marginBottom: '10px' }}>
                                Você <strong>autoriza fotos do antes e depois</strong> para usarmos no Instagram e site da clínica. Em troca, paga <strong>apenas o custo do procedimento</strong>, com desconto real de mais de 50%.
                            </p>
                            <p style={{ fontSize: '0.95rem', color: '#666', marginBottom: '0' }}>
                                <i className="bi bi-check-circle-fill text-success me-1"></i> Mesma dentista, mesma técnica, mesma resina de alta performance. <strong>Não é qualidade inferior por ser mais barato.</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ==========================================
                ANTES E DEPOIS — PROVA SOCIAL
               ========================================== */}
            <section className="prova-social-section wave-bg">
                <div className="container">
                    <div className="text-center mb-4">
                        <h2 className="section-title" style={{ color: 'var(--branco)' }}>
                            Transformações Reais no Grajaú
                        </h2>
                        <p className="section-subtitle" style={{ color: 'var(--branco)', opacity: 0.95 }}>
                            Veja como nossas Facetas de Resina transformam sorrisos na Zona Sul de SP
                        </p>
                    </div>

                    <div className="carousel-container">
                        <button className="carousel-control prev" onClick={prevSlide} aria-label="Depoimento anterior">
                            <i className="bi bi-chevron-left"></i>
                        </button>

                        <div
                            className="carousel-track-wrapper"
                            onTouchStart={handleTouchStart}
                            onTouchMove={handleTouchMove}
                            onTouchEnd={handleTouchEnd}
                        >
                            <div
                                className="carousel-track"
                                style={{
                                    transform: `translateX(-${currentIndex * (100 / itemsToShow)}%)`
                                }}
                            >
                                {cases.map((patient) => (
                                    <div className="carousel-item-custom" key={patient.id}>
                                        <div className="before-after-card">
                                            <div className="before-after-image">
                                                <span className="before-after-label">CASO {patient.id}</span>
                                                <div className="d-flex w-100 h-100">
                                                    <div className="w-50 h-100 border-end d-flex align-items-center justify-content-center bg-light overflow-hidden">
                                                        {patient.imgBefore ? (
                                                            <img
                                                                src={patient.imgBefore}
                                                                alt={`Dentes do paciente ${patient.id} antes do tratamento`}
                                                                width="400"
                                                                height="300"
                                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                            />
                                                        ) : (
                                                            <span className="text-muted small">ANTES</span>
                                                        )}
                                                    </div>
                                                    <div className="w-50 h-100 d-flex align-items-center justify-content-center overflow-hidden">
                                                        {patient.imgAfter ? (
                                                            <img
                                                                src={patient.imgAfter}
                                                                alt={`Dentes do paciente ${patient.id} depois do tratamento com facetas em resina`}
                                                                width="400"
                                                                height="300"
                                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                            />
                                                        ) : (
                                                            <span className="text-primary small">DEPOIS</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="before-after-content" style={{ padding: '15px', textAlign: 'left' }}>
                                                <p className="mb-0" style={{ fontSize: '0.85rem', color: '#2d3436', lineHeight: '1.4' }}>
                                                    {patient.after}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <button className="carousel-control next" onClick={nextSlide} aria-label="Próximo depoimento">
                            <i className="bi bi-chevron-right"></i>
                        </button>

                        <div className="carousel-indicators">
                            {Array.from({ length: cases.length - itemsToShow + 1 }).map((_, idx) => (
                                <button
                                    key={idx}
                                    className={`indicator-dot ${currentIndex === idx ? 'active' : ''}`}
                                    onClick={() => setCurrentIndex(idx)}
                                    aria-label={`Ir para slide ${idx + 1}`}
                                />
                            ))}
                        </div>
                    </div>

                    <div className="text-center mt-4">
                        <button
                            className="cta-button"
                            onClick={() => handleWhatsAppClick('social_cta')}
                        >
                            <i className="bi bi-whatsapp"></i>
                            EU QUERO ESSE RESULTADO TAMBÉM
                        </button>
                    </div>
                </div>
            </section>

            {/* ==========================================
                PREÇO + CTA FINAL
               ========================================== */}
            <section style={{ background: '#fff', padding: '60px 0' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7 text-center">
                            <div style={{
                                background: 'linear-gradient(135deg, rgba(51,153,255,0.05) 0%, rgba(51,217,255,0.08) 100%)',
                                border: '2px solid var(--azul-claro)',
                                borderRadius: '20px',
                                padding: '35px 25px',
                                marginBottom: '25px'
                            }}>
                                <p style={{ color: '#666', fontSize: '1rem', marginBottom: '5px' }}>
                                    Facetas em Resina · Paciente Modelo
                                </p>
                                <div style={{ fontSize: '3rem', fontWeight: '900', color: 'var(--azul-escuro)', lineHeight: '1' }}>
                                    A partir de R$ 1.197,90
                                </div>
                                <p style={{ color: '#555', fontSize: '0.9rem', marginTop: '12px', fontWeight: '600' }}>
                                    💰 Dinheiro &nbsp;|&nbsp; 💳 Cartão em até 12x &nbsp;|&nbsp; 📱 PIX
                                </p>
                                <p style={{ color: '#FF4757', fontWeight: '800', fontSize: '0.85rem', marginTop: '5px' }}>
                                    ⚠️ Últimas vagas para Paciente Modelo no Grajaú
                                </p>
                            </div>

                            <button
                                className="cta-button-large"
                                onClick={() => handleWhatsAppClick('cta_final')}
                            >
                                <i className="bi bi-whatsapp"></i>
                                AGENDAR AVALIAÇÃO GRATUITA
                            </button>

                            <div style={{ marginTop: '30px', background: '#f8fbff', border: '2px dashed #3399FF', borderRadius: '15px', padding: '20px' }}>
                                <p style={{ fontSize: '1.1rem', color: '#555', marginBottom: '5px' }}>
                                    <i className="bi bi-geo-alt-fill text-primary"></i> <strong>Av. Prefeito Paulo Lauro, 889, Grajaú, SP</strong>
                                </p>
                                <p style={{ fontSize: '0.9rem', color: '#777', marginBottom: '0' }}>
                                    <i className="bi bi-compass"></i> Próximo à Estação Grajaú e Av. Belmira Marin
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ==========================================
                RODAPÉ
               ========================================== */}
            <footer className="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="footer-logo">
                                <i className="bi bi-heart-pulse-fill"></i> LUPPE SAÚDE
                            </div>
                            <p style={{ fontSize: '1.1rem', marginBottom: '10px' }}>Odontologia</p>

                            <div className="footer-address">
                                <p>
                                    <i className="bi bi-geo-alt-fill"></i>
                                    <strong>Avenida Prefeito Paulo Lauro, 889</strong><br />
                                    <span style={{ marginLeft: '30px' }}>Grajaú, São Paulo - SP</span>
                                </p>
                                <p>
                                    <i className="bi bi-telephone-fill"></i>
                                    <strong>(11) 93930-0849</strong>
                                </p>
                                <p>
                                    <i className="bi bi-instagram"></i>
                                    <a
                                        href="https://www.instagram.com/clinicaluppe/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: 'var(--azul-claro)', textDecoration: 'none' }}
                                    >
                                        @clinicaluppe
                                    </a>
                                </p>
                                <p>
                                    <i className="bi bi-whatsapp"></i>
                                    <a
                                        href="https://wa.me/5511939300849"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: 'var(--azul-claro)', textDecoration: 'none' }}
                                    >
                                        Fale conosco pelo WhatsApp
                                    </a>
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <h3 style={{ color: 'var(--azul-claro)', marginBottom: '20px', fontSize: '1.3rem' }}>
                                Nossa Missão
                            </h3>
                            <div className="footer-mission">
                                <p style={{ marginBottom: 0, fontSize: '1.05rem' }}>
                                    "Tornar o atendimento odontológico <strong>acessível</strong>,
                                    <strong> técnico</strong> e <strong>humano</strong>."
                                </p>
                            </div>

                            <div className="mt-4">
                                <h4 style={{ color: 'var(--azul-claro)', fontSize: '1.1rem', marginBottom: '15px' }}>
                                    Serviços em Destaque
                                </h4>
                                <ul style={{ listStyle: 'none', padding: 0, lineHeight: '2' }}>
                                    <li><i className="bi bi-check-circle-fill" style={{ color: 'var(--azul-claro)', marginRight: '10px' }}></i>Facetas em Resina</li>
                                    <li><i className="bi bi-check-circle-fill" style={{ color: 'var(--azul-claro)', marginRight: '10px' }}></i>Estética Bucal</li>
                                    <li><i className="bi bi-check-circle-fill" style={{ color: 'var(--azul-claro)', marginRight: '10px' }}></i>Odontologia Geral</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="footer-bottom">
                        <p>&copy; 2026 Luppe Saúde - Odontologia. Todos os direitos reservados.</p>
                        <p>
                            Desenvolvido com <i className="bi bi-heart-fill" style={{ color: '#FF4757' }}></i> para transformar sorrisos na Zona Sul de SP
                        </p>
                    </div>
                </div>
            </footer>

            {/* Sticky CTA Mobile */}
            {showSticky && (
                <div
                    onClick={() => handleWhatsAppClick('sticky_mobile')}
                    className="sticky-cta-mobile"
                    style={{ cursor: 'pointer' }}
                    title="Agendar Avaliação"
                >
                    {notificationText && (
                        <div className="whatsapp-notification">
                            {notificationText}
                        </div>
                    )}
                    <i className="bi bi-whatsapp"></i>
                </div>
            )}
        </div>
    );
}

export default OriginalLP;
